"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateIssuesMap = exports.updateIssueByIdAction = exports.unlinkIssueAction = exports.restoreIssuesAction = exports.reducer = exports.mergeIssuePendingUpdates = exports.maybeRemoveFromLogAfterUnpublishAction = exports.maybeRemoveFromLogAfterBulkUnpublishAction = exports.issuesRestoreStart = exports.issuesRestoreEnd = exports.issuesRefreshStart = exports.issuesFetchSuccess = exports.issuesFetchStart = exports.issuesFetchFailure = exports.issuesBatchDeleteByIdSuccess = exports.issuesBatchDeleteByIdFailure = exports.issueUpdateByIdSuccess = exports.issueUpdateByIdStart = exports.issueUpdateByIdFailure = exports.issueFetchByIdSuccess = exports.issueFetchByIdStart = exports.issueFetchByIdFailure = exports.issueDeleteByIdSuccess = exports.issueDeleteByIdStart = exports.issueDeleteByIdFailure = exports.issueCreateSuccess = exports.issueCreateStart = exports.issueCreateFailure = exports.issueBatchUpdateByIdSuccess = exports.issueBatchUpdateByIdStart = exports.issueBatchUpdateByIdFailure = exports.issueBatchDeleteByIdStart = exports.issueBatchCreateSuccess = exports.issueBatchCreateStart = exports.issueBatchCreateFailure = exports.initialState = exports.getTotalNumberOfIssues = exports.getOrderedIssues = exports.getIssuesState = exports.getIssuesPagination = exports.getIssuesDeletionCount = exports.getIssuesByIds = exports.getIssueFetchErrorStatusByIssueId = exports.getIssueChannelSelectors = exports.getIssueById = exports.getIsUnlinkingAnyIssue = exports.getIsRestoringAnyIssue = exports.getIsLoadingIssueCollection = exports.getIsFetchingIssueById = exports.getIsDeletingAnyIssue = exports.getIsCreatingIssueById = exports.getIsCreatingAnyIssue = exports.getHasIssuesCollectionFetchSuccess = exports.getHasIssuesCollectionFetchErrored = exports.getErrorMessage = exports.getChannelInitialValues = exports.fetchIssuesByUidsAction = exports.fetchIssuesAction = exports.fetchIssueByIdAction = exports.fetchBatchIssuesAction = exports.deleteIssueByIdAction = exports.createIssueAction = exports.bulkEditIssuesAction = exports.bulkDeleteIssuesSuccess = exports.bulkDeleteIssuesAction = exports.batchCreateIssuesAction = exports.batchCreateIssueActionWithRetries = exports.STATE_KEY = exports.DEFAULT_ISSUES_CHANNEL = void 0;
var _uuid = require("uuid");
var _memoize = _interopRequireDefault(require("lodash/memoize"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _chunk = _interopRequireDefault(require("lodash/chunk"));
var _difference = _interopRequireDefault(require("lodash/difference"));
var _uniqBy = _interopRequireDefault(require("lodash/uniqBy"));
var _toolkit = require("@reduxjs/toolkit");
var _fetchHelpers = require("../fetchHelpers");
var _sheets = require("./sheets");
var _documents = require("./documents");
var _issueTableSelection = require("./issueTableSelection");
var _issuesCollection = require("./issuesCollection.bulkActionsHelpers");
var _issueActionsTracking = require("../../../utils/analytics/issueActionsTracking");
var _issuesQueryClient = require("../../../../sdk/issuesQueryClient");
var _trim = _interopRequireDefault(require("lodash/trim"));
var _issueSnapshots = require("./issueSnapshots");
var _queryClientUtils = require("../../../../sdk/util/queryClientUtils");
var _defaultParams = require("../../issuesFetchParams/defaultParams");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const DEFAULT_ISSUES_CHANNEL = exports.DEFAULT_ISSUES_CHANNEL = "DEFAULT_ISSUES_CHANNEL";
const getChannelInitialValues = () => ({
  [_fetchHelpers.STATUS_KEY]: _fetchHelpers.FetchStatus.Initial,
  orderedIds: [],
  pendingFetchRequestId: undefined
});
exports.getChannelInitialValues = getChannelInitialValues;
const initialState = exports.initialState = {
  entitiesMap: {},
  pendingUpdatesMap: {},
  pendingFetchByIdRequestMap: {},
  issueErrorMap: {},
  deletedItemsCount: 0,
  pendingCreationMap: {},
  pendingCreation: false,
  pendingDeletionMap: {},
  pendingRestoreMap: {},
  channels: {
    [DEFAULT_ISSUES_CHANNEL]: getChannelInitialValues()
  }
};
const getChannelForReducer = _ref => {
  let {
    state,
    channelIdFromPayload
  } = _ref;
  const channelId = channelIdFromPayload !== null && channelIdFromPayload !== void 0 ? channelIdFromPayload : DEFAULT_ISSUES_CHANNEL;
  if (!state.channels[channelId]) {
    state.channels[channelId] = getChannelInitialValues();
  }
  return state.channels[channelId];
};
const issuesCollectionSlice = (0, _toolkit.createSlice)({
  name: "issues",
  initialState,
  reducers: {
    issuesFetchStart: (state, action) => {
      if (action.payload.shouldResetChannel) {
        state.channels[action.payload.channelId || DEFAULT_ISSUES_CHANNEL] = getChannelInitialValues();
      }
      const channel = getChannelForReducer({
        channelIdFromPayload: action.payload.channelId,
        state
      });
      channel[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Loading;
      channel.pendingFetchRequestId = action.payload.requestId;
    },
    issuesFetchSuccess: (state, action) => {
      const {
        requestId,
        response
      } = action.payload;
      /**
       * @TODO: right now updating the issues cache and storing the information about
       * a particular issue "channel" is complected here... eventually we should rename
       * `issuesFetchStart`, `issuesFetchSuccess`, and `issuesFetchFailure` to indicate that they
       * are just modifying the channel metadata, and instead of updating the entities map
       * here we should dispatch `updateIssuesMap`
       */
      // update the issues map with the newest value, and get the ordered ids from the response
      const issueIds = response.results.reduce((ids, issue) => {
        state.entitiesMap[issue.id] = issue;
        ids.push(issue.id);
        return ids;
      }, []);
      const channel = getChannelForReducer({
        channelIdFromPayload: action.payload.channelId,
        state
      }); // ignore any payloads that aren't part of the most recently called request for this channel.
      if (requestId !== channel.pendingFetchRequestId) {
        return;
      }
      channel[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Success;
      channel.orderedIds = issueIds;
      channel.pagination = response.pagination;
      channel.pendingFetchRequestId = undefined;
    },
    issuesFetchFailure: (state, action) => {
      const {
        requestId,
        err
      } = action.payload;
      const channel = getChannelForReducer({
        channelIdFromPayload: action.payload.channelId,
        state
      });
      // ignore any payloads that aren't part of the most recently called request
      if (requestId !== channel.pendingFetchRequestId) {
        return;
      }
      channel.pendingFetchRequestId = undefined;
      channel[_fetchHelpers.STATUS_KEY] = _fetchHelpers.FetchStatus.Error;
      channel.errMessage = err === null || err === void 0 ? void 0 : err.details;
    },
    issuesRefreshStart: (state, action) => {
      const channel = getChannelForReducer({
        channelIdFromPayload: action.payload.channelId,
        state
      });
      channel.pendingFetchRequestId = action.payload.requestId;
    },
    updateIssuesMap: (state, action) => {
      const issues = action.payload.issues;
      issues.forEach(issue => {
        state.entitiesMap[issue.id] = issue;
      });
    },
    issueFetchByIdStart: (state, action) => {
      state.pendingFetchByIdRequestMap[action.payload.id] = action.payload.requestId;
    },
    issueFetchByIdSuccess: (state, action) => {
      const {
        response,
        requestId
      } = action.payload;
      // ignore any payloads that aren't part of the most recently called request
      if (state.pendingFetchByIdRequestMap[response.id] !== requestId) {
        return;
      }
      state.entitiesMap = {
        ...state.entitiesMap,
        [response.id]: response
      };
      delete state.pendingFetchByIdRequestMap[response.id];
      delete state.issueErrorMap[response.id];
    },
    issueFetchByIdFailure: (state, action) => {
      const {
        id,
        requestId,
        status
      } = action.payload;
      state.issueErrorMap = {
        ...state.issueErrorMap,
        [id]: status
      };
      // ignore any payloads that aren't part of the most recently called request
      if (state.pendingFetchByIdRequestMap[id] !== requestId) {
        return;
      }
      delete state.pendingFetchByIdRequestMap[id];
    },
    issueUpdateByIdStart: (state, action) => {
      state.pendingUpdatesMap = {
        ...state.pendingUpdatesMap,
        [action.payload.id]: action.payload.issueChanges
      };
    },
    issueUpdateByIdSuccess: (state, action) => {
      state.entitiesMap = {
        ...state.entitiesMap,
        [action.payload.id]: action.payload
      };
      delete state.pendingUpdatesMap[action.payload.id];
      // we want to clear any other pending fetches, because
      // this update has just returned the most recent updated truth.
      delete state.pendingFetchByIdRequestMap[action.payload.id];
    },
    issueBatchUpdateByIdStart: (state, action) => {
      const newPendingUpdatesById = {};
      action.payload.issueUids.forEach(issueUid => {
        newPendingUpdatesById[issueUid] = action.payload.issueChanges;
      });
      state.pendingUpdatesMap = {
        ...state.pendingUpdatesMap,
        ...newPendingUpdatesById
      };
    },
    issueBatchUpdateByIdSuccess: (state, action) => {
      const updatedIssuesById = {};
      action.payload.issues.forEach(issue => {
        updatedIssuesById[issue.id] = issue;
        delete state.pendingUpdatesMap[issue.id];
      });
      state.entitiesMap = {
        ...state.entitiesMap,
        ...updatedIssuesById
      };
    },
    issueBatchUpdateByIdFailure: (state, action) => {
      action.payload.issueUids.forEach(issueUid => {
        delete state.pendingUpdatesMap[issueUid];
      });
    },
    issueUpdateByIdFailure: (state, action) => {
      delete state.pendingUpdatesMap[action.payload.id];
    },
    issueDeleteByIdStart: (state, action) => {
      if (action.payload.id) {
        state.pendingDeletionMap[action.payload.id] = true;
      }
    },
    issueBatchDeleteByIdStart: (state, action) => {
      action.payload.issueUids.forEach(issueUid => {
        state.pendingDeletionMap[issueUid] = true;
      });
    },
    issueDeleteByIdSuccess: (state, action) => {
      delete state.entitiesMap[action.payload.id];
      delete state.pendingUpdatesMap[action.payload.id];
      delete state.pendingDeletionMap[action.payload.id];
      state.deletedItemsCount += 1;
    },
    issuesBatchDeleteByIdSuccess: (state, action) => {
      action.payload.issueUids.forEach(issueUid => {
        delete state.entitiesMap[action.payload.id];
        delete state.pendingUpdatesMap[issueUid];
        delete state.pendingDeletionMap[issueUid];
      });
      state.deletedItemsCount += action.payload.issueUids.length;
    },
    issueDeleteByIdFailure: (state, action) => {
      delete state.pendingUpdatesMap[action.payload.id];
      delete state.pendingDeletionMap[action.payload.id];
    },
    issuesBatchDeleteByIdFailure: (state, action) => {
      action.payload.issueUids.forEach(issueUid => {
        delete state.pendingUpdatesMap[issueUid];
        delete state.pendingDeletionMap[issueUid];
      });
    },
    issueCreateStart: (state, action) => {
      if (action.payload.id) {
        state.pendingCreationMap[action.payload.id] = true;
      }
      state.pendingCreation = true;
    },
    issueCreateSuccess: (state, action) => {
      if (!action.payload.id) {
        return;
      }
      delete state.pendingCreationMap[action.payload.id];
      state.entitiesMap = {
        ...state.entitiesMap,
        [action.payload.id]: action.payload
      };
      state.pendingCreation = false;
    },
    issueCreateFailure: (state, action) => {
      if (action.payload.id) {
        delete state.pendingCreationMap[action.payload.id];
      }
      state.pendingCreation = false;
    },
    issueBatchCreateStart: (state, action) => {
      const issues = action.payload;
      issues.forEach(issue => {
        if (issue.id) {
          state.pendingCreationMap[issue.id] = true;
        }
      });
      state.pendingCreation = true;
    },
    issueBatchCreateSuccess: (state, action) => {
      const issues = action.payload;
      const createdIssues = {};
      issues.forEach(issue => {
        if (!issue.id) {
          return;
        }
        delete state.pendingCreationMap[issue.id];
        createdIssues[issue.id] = issue;
      });
      state.entitiesMap = {
        ...state.entitiesMap,
        ...createdIssues
      };
      state.pendingCreation = false;
    },
    issueBatchCreateFailure: (state, action) => {
      const issues = action.payload;
      issues.forEach(issue => {
        if (issue.id) {
          delete state.pendingCreationMap[issue.id];
        }
      });
      state.pendingCreation = false;
    },
    issuesRestoreStart: (state, action) => {
      const {
        issues
      } = action.payload;
      issues.forEach(issue => {
        if (issue.id) {
          state.pendingRestoreMap[issue.id] = true;
        }
      });
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    issuesRestoreEnd: (state, action) => {
      // to signal linter it is intentionally unused.
      state.pendingRestoreMap = {};
    }
  },
  extraReducers: builder => {
    /**
     * Update the issue cache when a new snapshot is created.
     * Otherwise, the issue cache will be outdated, until we re-fetch the issue.
     */
    builder.addCase(_issueSnapshots.issueSnapshotUploadSuccess, (state, action) => {
      const {
        issueId,
        snapshotUrn
      } = action.payload;
      const issue = state.entitiesMap[issueId];
      if (!issue) {
        return;
      }
      state.entitiesMap[issueId].snapshotUrn = snapshotUrn;
    });
  }
});
const reducer = exports.reducer = issuesCollectionSlice.reducer;
const STATE_KEY = exports.STATE_KEY = issuesCollectionSlice.name;
const getIssuesState = state => state[STATE_KEY];

// this is useful because it means the log can reload the page on deletion
exports.getIssuesState = getIssuesState;
const getIssuesDeletionCount = exports.getIssuesDeletionCount = (0, _toolkit.createSelector)(getIssuesState, state => state.deletedItemsCount);
const mergeIssuePendingUpdates = (issue, issuePendingUpdates) => {
  var _issuePendingUpdates;
  if ((_issuePendingUpdates = issuePendingUpdates) !== null && _issuePendingUpdates !== void 0 && _issuePendingUpdates.customAttributes) {
    issuePendingUpdates = {
      ...issuePendingUpdates,
      customAttributes: issuePendingUpdates.customAttributes.reduce((pendingCustomAttributes, pendingTuple) => {
        const currentAttributeTupleIndex = pendingCustomAttributes.findIndex(_ref2 => {
          let {
            attributeDefinitionId
          } = _ref2;
          return attributeDefinitionId === pendingTuple.attributeDefinitionId;
        });
        if (currentAttributeTupleIndex !== -1) {
          //replace with the new value
          pendingCustomAttributes.splice(currentAttributeTupleIndex, 1, pendingTuple);
        } else {
          //add the new tuple
          pendingCustomAttributes.push(pendingTuple);
        }
        return pendingCustomAttributes;
      }, [...issue.customAttributes])
    };
  }
  return !(0, _isEmpty.default)(issuePendingUpdates) ? {
    ...issue,
    ...issuePendingUpdates
  } : issue;
};
exports.mergeIssuePendingUpdates = mergeIssuePendingUpdates;
const getIssueById = state => issueId => {
  if (!issueId) {
    return undefined;
  }
  const issueState = getIssuesState(state);
  const issue = issueState.entitiesMap[issueId];
  if (!issue) {
    return undefined;
  }
  return mergeIssuePendingUpdates(issue, issueState.pendingUpdatesMap[issueId]);
};
exports.getIssueById = getIssueById;
const getIssuesByIds = state => issueIds => {
  const issueState = getIssuesState(state);
  return issueIds.map(issueId => {
    const issue = issueState.entitiesMap[issueId];
    if (!issue) {
      return undefined;
    }
    return mergeIssuePendingUpdates(issue, issueState.pendingUpdatesMap[issueId]);
  }).filter(Boolean);
};
exports.getIssuesByIds = getIssuesByIds;
const getIssueFetchErrorStatusByIssueId = state => issueId => {
  if (!issueId) {
    return undefined;
  }
  const issueState = getIssuesState(state);
  return issueState.issueErrorMap[issueId];
};
exports.getIssueFetchErrorStatusByIssueId = getIssueFetchErrorStatusByIssueId;
const getIsFetchingIssueById = state => issueId => {
  if (!issueId) {
    return false;
  }
  const issueState = getIssuesState(state);
  return !!issueState.pendingFetchByIdRequestMap[issueId];
};
exports.getIsFetchingIssueById = getIsFetchingIssueById;
const getIsCreatingIssueById = state => issueId => {
  if (!issueId) {
    return false;
  }
  const issueState = getIssuesState(state);
  return !!issueState.pendingCreationMap[issueId];
};
exports.getIsCreatingIssueById = getIsCreatingIssueById;
const getIsCreatingAnyIssue = exports.getIsCreatingAnyIssue = (0, _toolkit.createSelector)(getIssuesState, state => {
  return !(0, _isEmpty.default)(state.pendingCreationMap) || state.pendingCreation;
});
const getIsDeletingAnyIssue = exports.getIsDeletingAnyIssue = (0, _toolkit.createSelector)(getIssuesState, state => {
  return !(0, _isEmpty.default)(state.pendingDeletionMap);
});
const getIsUnlinkingAnyIssue = exports.getIsUnlinkingAnyIssue = (0, _toolkit.createSelector)(getIssuesState, state => {
  return !(0, _isEmpty.default)(state.pendingUpdatesMap) && Object.values(state.pendingUpdatesMap).some(pendingUpdate => {
    var _pendingUpdate$linked;
    return ((_pendingUpdate$linked = pendingUpdate.linkedDocuments) === null || _pendingUpdate$linked === void 0 ? void 0 : _pendingUpdate$linked.length) === 0;
  });
});
const getIsRestoringAnyIssue = exports.getIsRestoringAnyIssue = (0, _toolkit.createSelector)(getIssuesState, state => {
  return !(0, _isEmpty.default)(state.pendingRestoreMap);
});

/**
 * The map of issue uids to issues don't care about how they are populated...
 * we just want to store the most up to date information that we've received from the server.
 *
 * The status, pagination, and list of ordered ids are tied to a specific "channel" of issues,
 * and we may want multiple channels of these at a time... for example an issues list for one sheet
 * without having to clear the store (or worry about state mixups) for the issues list on another sheet.
 *
 * So these new channels and their selectors can be created as needed by using the below function.
 *
 * @TODO: at the moment, none of the dispatched actions are defining a channel ID, so for now
 * we're still always using the default channel ID no matter what.
 * Soon though we should make it so that you must define the channel id when you fetch multiple issues.
 */
const getIssueChannelSelectors = exports.getIssueChannelSelectors = (0, _memoize.default)(channelId => {
  return {
    isLoading: (0, _toolkit.createSelector)(getIssuesState, state => {
      return (0, _fetchHelpers.isLoading)(state.channels[channelId] || {});
    }),
    isErrored: (0, _toolkit.createSelector)(getIssuesState, state => {
      return (0, _fetchHelpers.isErrored)(state.channels[channelId] || {});
    }),
    getErrorMessage: (0, _toolkit.createSelector)(getIssuesState, state => {
      const channel = state.channels[channelId] || {};
      return (channel === null || channel === void 0 ? void 0 : channel.errMessage) || "";
    }),
    isSuccess: (0, _toolkit.createSelector)(getIssuesState, state => {
      return (0, _fetchHelpers.isSuccess)(state.channels[channelId] || {});
    }),
    getPagination: (0, _toolkit.createSelector)(getIssuesState, state => {
      const channel = state.channels[channelId] || {};
      return channel.pagination;
    }),
    getTotalNumber: (0, _toolkit.createSelector)(getIssuesState, state => {
      const channel = state.channels[channelId] || {};
      return channel.pagination ? channel.pagination.totalResults : 0;
    }),
    // caution: this is only useful for infinite scroll components for now
    hasNextPage: (0, _toolkit.createSelector)(getIssuesState, state => {
      const channel = state.channels[channelId] || {};
      return channel.pagination ? channel.orderedIds.length < channel.pagination.totalResults : true;
    }),
    // @TODO: refactor this and just use getIssuesByIds
    getOrderedIssues: (0, _toolkit.createSelector)(state => {
      const channel = getIssuesState(state).channels[channelId] || {
        orderedIds: []
      };
      return channel.orderedIds;
    }, state => getIssuesState(state).entitiesMap, state => getIssuesState(state).pendingUpdatesMap, (orderedIds, entitiesMap, pendingUpdatesMap) => {
      return orderedIds.map(issueId => {
        const issue = entitiesMap[issueId];
        if (!issue) {
          return undefined;
        }
        return mergeIssuePendingUpdates(issue, pendingUpdatesMap[issueId]);
      }).filter(Boolean);
    })
  };
});

// the following is for backwards compatability on components that were assuming only one issues channel:
const defaultIssueChannelSelectors = getIssueChannelSelectors(DEFAULT_ISSUES_CHANNEL);
const getOrderedIssues = exports.getOrderedIssues = defaultIssueChannelSelectors.getOrderedIssues;
const getIsLoadingIssueCollection = exports.getIsLoadingIssueCollection = defaultIssueChannelSelectors.isLoading;
const getHasIssuesCollectionFetchErrored = exports.getHasIssuesCollectionFetchErrored = defaultIssueChannelSelectors.isErrored;
const getErrorMessage = exports.getErrorMessage = defaultIssueChannelSelectors.getErrorMessage;
const getHasIssuesCollectionFetchSuccess = exports.getHasIssuesCollectionFetchSuccess = defaultIssueChannelSelectors.isSuccess;
const getIssuesPagination = exports.getIssuesPagination = defaultIssueChannelSelectors.getPagination;
const getTotalNumberOfIssues = exports.getTotalNumberOfIssues = defaultIssueChannelSelectors.getTotalNumber;
const {
  issuesFetchStart,
  issuesFetchSuccess,
  issuesFetchFailure,
  issuesRefreshStart,
  updateIssuesMap,
  issueFetchByIdStart,
  issueFetchByIdSuccess,
  issueFetchByIdFailure,
  issueUpdateByIdStart,
  issueUpdateByIdSuccess,
  issueUpdateByIdFailure,
  issueBatchUpdateByIdStart,
  issueBatchUpdateByIdSuccess,
  issueBatchUpdateByIdFailure,
  issueDeleteByIdSuccess,
  issuesBatchDeleteByIdSuccess,
  issueDeleteByIdFailure,
  issuesBatchDeleteByIdFailure,
  issueCreateStart,
  issueBatchCreateStart,
  issueBatchCreateSuccess,
  issueBatchCreateFailure,
  issueCreateSuccess,
  issueCreateFailure,
  issueDeleteByIdStart,
  issueBatchDeleteByIdStart,
  issuesRestoreStart,
  issuesRestoreEnd
} = issuesCollectionSlice.actions;
exports.issuesRestoreEnd = issuesRestoreEnd;
exports.issuesRestoreStart = issuesRestoreStart;
exports.issueBatchDeleteByIdStart = issueBatchDeleteByIdStart;
exports.issueDeleteByIdStart = issueDeleteByIdStart;
exports.issueCreateFailure = issueCreateFailure;
exports.issueCreateSuccess = issueCreateSuccess;
exports.issueBatchCreateFailure = issueBatchCreateFailure;
exports.issueBatchCreateSuccess = issueBatchCreateSuccess;
exports.issueBatchCreateStart = issueBatchCreateStart;
exports.issueCreateStart = issueCreateStart;
exports.issuesBatchDeleteByIdFailure = issuesBatchDeleteByIdFailure;
exports.issueDeleteByIdFailure = issueDeleteByIdFailure;
exports.issuesBatchDeleteByIdSuccess = issuesBatchDeleteByIdSuccess;
exports.issueDeleteByIdSuccess = issueDeleteByIdSuccess;
exports.issueBatchUpdateByIdFailure = issueBatchUpdateByIdFailure;
exports.issueBatchUpdateByIdSuccess = issueBatchUpdateByIdSuccess;
exports.issueBatchUpdateByIdStart = issueBatchUpdateByIdStart;
exports.issueUpdateByIdFailure = issueUpdateByIdFailure;
exports.issueUpdateByIdSuccess = issueUpdateByIdSuccess;
exports.issueUpdateByIdStart = issueUpdateByIdStart;
exports.issueFetchByIdFailure = issueFetchByIdFailure;
exports.issueFetchByIdSuccess = issueFetchByIdSuccess;
exports.issueFetchByIdStart = issueFetchByIdStart;
exports.updateIssuesMap = updateIssuesMap;
exports.issuesRefreshStart = issuesRefreshStart;
exports.issuesFetchFailure = issuesFetchFailure;
exports.issuesFetchSuccess = issuesFetchSuccess;
exports.issuesFetchStart = issuesFetchStart;
const fetchIssuesAction = (_ref3, includeDeletedMarkups) => {
  let {
    limit,
    offset,
    sortBy,
    filterBy
  } = _ref3;
  return async (dispatch, getState, _ref4) => {
    let {
      sdk
    } = _ref4;
    const requestId = (0, _uuid.v4)();
    let response;
    dispatch(issuesFetchStart({
      requestId
    }));
    try {
      if (filterBy && Object.keys(filterBy).some(key => _defaultParams.PARAMS_REQUIRE_BATCH_GET.includes(key))) {
        response = await sdk.Issues.batchGet({
          limit,
          offset,
          sortBy,
          filterBy
        });
      } else {
        response = await sdk.Issues.getAll({
          limit,
          offset,
          sortBy,
          filterBy
        });
      }
    } catch (err) {
      dispatch(issuesFetchFailure({
        requestId,
        err
      }));
      return;
    }
    dispatch(issuesFetchSuccess({
      response,
      requestId
    }));
    dispatch((0, _sheets.fetchIssuesSheetAssociation)({
      issues: response.results,
      useCache: true,
      includeDeletedMarkups
    }));
    dispatch((0, _documents.fetchIssuesDocumentAssociations)({
      issues: response.results,
      useCache: true
    }));
  };
};
exports.fetchIssuesAction = fetchIssuesAction;
const fetchBatchIssuesAction = function (_ref5) {
  let {
    limit,
    sortBy,
    filterBy
  } = _ref5;
  let isRefreshing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let onSuccess = arguments.length > 2 ? arguments[2] : undefined;
  return async (dispatch, getState, _ref6) => {
    var _filterBy$viewable;
    let {
      sdk
    } = _ref6;
    if (filterBy && (_filterBy$viewable = filterBy.viewable) !== null && _filterBy$viewable !== void 0 && _filterBy$viewable.some(viewableCriterion => !viewableCriterion.lineageUrn) && !filterBy.linkedDocumentUrn) {
      throw new Error("Filter by `viewable` requires also filter by `linkedDocumentUrn`.");
    }
    const requestId = (0, _uuid.v4)();
    if (isRefreshing) {
      dispatch(issuesRefreshStart({
        requestId
      }));
    } else {
      dispatch(issuesFetchStart({
        requestId,
        shouldResetChannel: true
      }));
    }
    try {
      const results = await (0, _fetchHelpers.fetchAllPaginatedResults)(offset => sdk.Issues.batchGet({
        limit,
        offset,
        sortBy,
        filterBy
      }));
      dispatch(issuesFetchSuccess({
        response: {
          pagination: {
            limit,
            offset: 0,
            totalResults: results.length
          },
          results
        },
        requestId
      }));
      onSuccess === null || onSuccess === void 0 || onSuccess(results);
      return true;
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("Error in fetching an issue batch", err);
      dispatch(issuesFetchFailure({
        requestId,
        err
      }));
      return false;
    }
  };
};

/**
 * We need to have this special fetching function because if there are more than a max
 * number of issue markups on the page the backend won't return all of the associated issues in a single request.
 *
 * So, we make concurrent requests as needed.
 *
 * This is used within the sheet viewer, in particular on initial load.
 * At some point we may want to consolidate the logic here with fetchBatchIssuesAction so
 * that fetchBatchIssuesAction will work with any limit, but we will need to do client side sorting
 * because each separate request will be sorted, but in aggregate they won't be.
 */
exports.fetchBatchIssuesAction = fetchBatchIssuesAction;
const fetchIssuesByUidsAction = _ref7 => {
  let {
    issueUids,
    filterBy
  } = _ref7;
  return async (dispatch, getState, _ref8) => {
    let {
      sdk
    } = _ref8;
    const issuesMap = new Map();
    /**
     * The maximum limit on the batchGet request on the server is 200, so in the rare case that there are
     * more than 180 issues on a sheet we do concurrent requests.
     *
     * (we use a bit less than the server limit just for some headroom)
     */
    const maxUidsPerRequest = 180;
    const batches = (0, _chunk.default)(issueUids, maxUidsPerRequest);
    try {
      const responses = await Promise.all(batches.map(async idListForRequest => {
        return sdk.Issues.batchGet({
          limit: maxUidsPerRequest,
          offset: 0,
          filterBy: {
            ...filterBy,
            id: idListForRequest
          }
        });
      }));
      responses.forEach(response => {
        if (response) {
          response.results.forEach(issue => {
            issuesMap.set(issue.id, issue);
          });
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Error in fetchIssuesByUidsAction: ".concat(e, ". No issues will be added.."));
      issuesMap.clear();
    }
    dispatch(updateIssuesMap({
      issues: [...issuesMap.values()]
    }));
    return issuesMap;
  };
};
exports.fetchIssuesByUidsAction = fetchIssuesByUidsAction;
const fetchIssueByIdAction = _ref9 => {
  let {
    id,
    includeDeletedMarkups = false,
    shouldFetchSheetAssociation = false
  } = _ref9;
  return async (dispatch, getState, _ref10) => {
    let {
      sdk
    } = _ref10;
    const requestId = (0, _uuid.v4)();
    let issue = undefined;
    dispatch(issueFetchByIdStart({
      id,
      requestId
    }));
    try {
      // don't send a request to the server, because it will surely fail.
      if (!(0, _uuid.validate)(id)) {
        throw new Error("id is not a valid GUID");
      }
      issue = await sdk.Issues.get(id);
    } catch (err) {
      dispatch(issueFetchByIdFailure({
        id,
        requestId,
        status: err.status
      }));
      return;
    }
    dispatch(issueFetchByIdSuccess({
      response: issue,
      requestId
    }));
    if (shouldFetchSheetAssociation) {
      dispatch((0, _sheets.fetchIssuesSheetAssociation)({
        issues: [issue],
        useCache: true,
        includeDeletedMarkups
      }));
    }
    dispatch((0, _documents.fetchIssuesDocumentAssociations)({
      issues: [issue],
      useCache: true
    }));
    return issue;
  };
};
exports.fetchIssueByIdAction = fetchIssueByIdAction;
const updateIssueByIdAction = _ref11 => {
  let {
    id,
    issueChanges,
    onSuccess,
    onFailure
  } = _ref11;
  return async (dispatch, getState, _ref12) => {
    let {
      sdk
    } = _ref12;
    let response = undefined;
    dispatch(issueUpdateByIdStart({
      id,
      issueChanges
    }));
    try {
      response = await sdk.Issues.update(id, issueChanges);
    } catch (error) {
      dispatch(issueUpdateByIdFailure({
        id
      }));
      onFailure && onFailure(error);
      return;
    }
    dispatch(issueUpdateByIdSuccess(response));
    onSuccess === null || onSuccess === void 0 || onSuccess(response);
  };
};
exports.updateIssueByIdAction = updateIssueByIdAction;
const createIssueAction = _ref13 => {
  let {
    issueData,
    onSuccess,
    onFailure,
    analyticsData = {},
    customCreateFn
  } = _ref13;
  return async (dispatch, getState, _ref14) => {
    let {
      sdk
    } = _ref14;
    let responseIssueData = null;
    dispatch(issueCreateStart(issueData));
    try {
      if (customCreateFn) {
        const queryClient = (0, _issuesQueryClient.getIssuesQueryClientInstance)();
        // invalidate cache since some consumers (e.g. Model Coordination) create Issues through Issues BE
        _queryClientUtils.INVALIDATE_ALL_ISSUES.forEach(queryKey => queryClient.removeQueries(queryKey));
        responseIssueData = await customCreateFn(issueData);
      } else {
        responseIssueData = await sdk.Issues.create(issueData);
      }
    } catch (error) {
      onFailure && onFailure(error);
      issueCreateFailure(issueData);
      return null;
    }
    dispatch(issueCreateSuccess(responseIssueData));
    onSuccess === null || onSuccess === void 0 || onSuccess(responseIssueData);
    (0, _issueActionsTracking.trackIssueCreateSuccess)({
      issue: responseIssueData,
      context: analyticsData
    });
    return responseIssueData;
  };
};
exports.createIssueAction = createIssueAction;
const batchCreateIssueActionWithRetries = _ref15 => {
  let {
    issuesToSave,
    onBeginSavingBatch
  } = _ref15;
  return async (dispatch, getState, _ref16) => {
    let {
      sdk
    } = _ref16;
    if (!issuesToSave.length) {
      return {
        issuesSaved: [],
        issuesErrored: []
      };
    }
    const maxPerRequest = 10;
    const batches = (0, _chunk.default)(issuesToSave, maxPerRequest);
    let issuesSaved = [];
    let issuesErrored = [];
    const saveBatch = async issuesBatch => {
      let issuesResponse = null;
      let errorResponse = null;
      try {
        issuesResponse = await sdk.Issues.batchCreate(issuesBatch);
      } catch (error) {
        errorResponse = error;
      }
      return {
        issues: issuesResponse,
        error: errorResponse
      };
    };
    const handleResponse = async _ref17 => {
      var _response$error, _response$error2;
      let {
        response,
        currentBatch,
        maxRetriesFor5xxErrors = 2,
        maxRetriesFor4xxErrors = 5
      } = _ref17;
      /**
       * This does some recursive work: if we get a 5xx error, we want to retry a number of times up to the retry count.
       * If we get a 4xx, we want to retry a number of times (after removing the problematic issues) up to the retry count.
       * The retry counts are separate... e.g., we could have a 4xx issues, and then retry it wihtout the problematic issues,
       * and then get a 5xx issue, and for the 5xx issue we would want to retry that same request up to the max retries for 5xx erros.
       *
       * ... this is needed because the server may be flaky, and because 4xx issues will only expose one error type at a time,
       * so just in case there are layers of problems that cause 4xx issues, we want to handle it.
       */
      if ((_response$error = response.error) !== null && _response$error !== void 0 && _response$error.status && response.error.status >= 500) {
        console.error("Got error in issues batch:", response.error, currentBatch);
        console.error("5xx retries remaining:", maxRetriesFor5xxErrors);
        if (maxRetriesFor5xxErrors > 0) {
          // retry once on 5xx errors
          response = await saveBatch(currentBatch);
          await handleResponse({
            response,
            currentBatch,
            maxRetriesFor4xxErrors,
            maxRetriesFor5xxErrors: maxRetriesFor5xxErrors - 1
          });
        } else {
          issuesErrored = [...issuesErrored, ...currentBatch];
        }
        return;
      }
      if ((_response$error2 = response.error) !== null && _response$error2 !== void 0 && _response$error2.status && response.error.status >= 400 && response.error.status < 500) {
        console.error("Got error in issues batch:", response.error, currentBatch);
        console.error("4xx retries remaining:", maxRetriesFor4xxErrors);
        if (maxRetriesFor4xxErrors > 0) {
          var _response$error$metad;
          // remove 4xx and retry without those issues...
          const problematicIssueIds = (((_response$error$metad = response.error.metadata) === null || _response$error$metad === void 0 ? void 0 : _response$error$metad.errors) || []).map(error => {
            var _error$detail2;
            const issueAtFault = currentBatch.find(issue => {
              var _error$detail;
              return issue.id === ((_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.id);
            });
            if (issueAtFault) {
              issuesErrored.push(issueAtFault);
            }
            return ((_error$detail2 = error.detail) === null || _error$detail2 === void 0 ? void 0 : _error$detail2.id) || "";
          });
          const batchWithoutProblematicIssues = currentBatch.filter(issue => {
            return !problematicIssueIds.includes(issue.id);
          });
          console.error("Retrying due to 4xx errors with new batch:", batchWithoutProblematicIssues);
          response = await saveBatch(batchWithoutProblematicIssues);
          await handleResponse({
            response,
            currentBatch: batchWithoutProblematicIssues,
            maxRetriesFor4xxErrors: maxRetriesFor4xxErrors - 1,
            maxRetriesFor5xxErrors
          });
        } else {
          issuesErrored = [...issuesErrored, ...currentBatch];
        }
        return;
      }
      if (response.issues) {
        issuesSaved = issuesSaved.concat(response.issues);
      }
    };
    for (let i = 0; i < batches.length; i++) {
      const issueIndex = i * maxPerRequest;
      onBeginSavingBatch({
        first: issueIndex + 1,
        last: issueIndex + batches[i].length
      });
      const response = await saveBatch(batches[i]);
      await handleResponse({
        response,
        currentBatch: batches[i]
      });
    }
    dispatch(updateIssuesMap({
      issues: issuesSaved
    }));

    // with all the various retries adding to the errored issue list,
    // it's possible to have duplicates there, which we don't want. so uniqBy fixes that.
    // ... we could also use a set for it from the beginning but working with arrays is a little easier
    return {
      issuesSaved,
      issuesErrored: (0, _uniqBy.default)(issuesErrored, "id")
    };
  };
};
exports.batchCreateIssueActionWithRetries = batchCreateIssueActionWithRetries;
const batchCreateIssuesAction = _ref18 => {
  let {
    issuesToSave,
    onSuccess,
    onFailure,
    customCreateFn
  } = _ref18;
  return async (dispatch, getState, _ref19) => {
    let {
      sdk
    } = _ref19;
    let issuesResponse;
    try {
      dispatch(issueBatchCreateStart(issuesToSave));
      if (customCreateFn) {
        issuesResponse = await customCreateFn();
      } else {
        issuesResponse = await sdk.Issues.batchCreate(issuesToSave);
      }
      onSuccess && onSuccess(issuesResponse);
      dispatch(issueBatchCreateSuccess(issuesResponse));
      return issuesResponse;
    } catch (error) {
      onFailure && onFailure();
      dispatch(issueBatchCreateFailure(issuesToSave));
      throw error;
    }
  };
};
exports.batchCreateIssuesAction = batchCreateIssuesAction;
const deleteIssueByIdAction = _ref20 => {
  let {
    id,
    comment,
    onSuccess,
    onFailure,
    shouldDeleteMarkup
  } = _ref20;
  return async (dispatch, getState, _ref21) => {
    let {
      sdk
    } = _ref21;
    dispatch(issueDeleteByIdStart({
      id
    }));
    try {
      await sdk.Issues.delete({
        issueId: id,
        comment: getTrimmedComment(comment)
      });
    } catch (err) {
      onFailure && onFailure(err);
      dispatch(issueDeleteByIdFailure({
        id
      }));
      return;
    }
    dispatch(issueDeleteByIdSuccess({
      id
    }));
    dispatch((0, _issueTableSelection.removeIdsFromSelectedIdsAction)({
      issueUids: [id]
    }));
    // if the client fails to delete the issue markup, if there is one,
    // then that's OK. Orphaned markups are acceptable for now.
    if (shouldDeleteMarkup) {
      dispatch((0, _sheets.tryDeleteMarkup)({
        issueId: id
      }));
    }

    // It's important to call onSuccess() at the end, so that implementations
    // never work on inconsistent or outdated store data.
    onSuccess && onSuccess();
  };
};
exports.deleteIssueByIdAction = deleteIssueByIdAction;
const getTrimmedComment = comment => {
  const trimmedValue = (0, _trim.default)(comment);
  return trimmedValue.length > 0 ? trimmedValue : undefined;
};
const bulkDeleteIssuesAction = _ref22 => {
  let {
    issueUids,
    comment,
    onSuccess,
    onPartialFailure,
    onFailure,
    shouldDeleteMarkups
  } = _ref22;
  return async (dispatch, getState, _ref23) => {
    let {
      sdk
    } = _ref23;
    if (issueUids.length === 0) {
      return;
    }
    let failureInfo = [];
    /**
     * The maximum limit on this batchUpdate request on the server is 100, and the request may time out at numbers close to that,
     * so in the case that there are more than 60 issues we do concurrent requests.
     */
    dispatch(issueBatchDeleteByIdStart({
      issueUids
    }));
    const maxUidsPerRequest = 50;
    const batches = (0, _chunk.default)(issueUids, maxUidsPerRequest);
    const resolvedBatches = await Promise.allSettled(batches.map(batch => {
      return (0, _issuesCollection.performActionOnIssueBatchWithRetry)({
        batch,
        asyncAction: async _ref24 => {
          let {
            issueUids
          } = _ref24;
          return await sdk.Issues.batchDelete({
            issueUids,
            comment: getTrimmedComment(comment)
          });
        }
      });
    }));
    resolvedBatches.forEach(resolvedBatch => {
      if (resolvedBatch.status === "fulfilled") {
        if (resolvedBatch.value.failureInfo.length) {
          failureInfo = failureInfo.concat(resolvedBatch.value.failureInfo);
        }
      } else {
        console.error("Unexpected error with batch:", resolvedBatch.reason);
      }
    });
    if (failureInfo.length === issueUids.length) {
      onFailure && onFailure();
      dispatch(issuesBatchDeleteByIdFailure({
        issueUids
      }));
      return;
    } else if (failureInfo.length) {
      onPartialFailure && onPartialFailure(failureInfo);
      dispatch(issuesBatchDeleteByIdFailure({
        issueUids
      }));
    } else {
      onSuccess && onSuccess();
      dispatch(bulkDeleteIssuesSuccess({
        issueUids,
        shouldDeleteMarkups
      }));
    }
  };
};

/**
 * In the case of a partial failure, this can be and should be called AFTER
 * the user acknowledges the partial failure modal, only on the issue sthat were successfully deleted
 */
exports.bulkDeleteIssuesAction = bulkDeleteIssuesAction;
const bulkDeleteIssuesSuccess = _ref25 => {
  let {
    issueUids,
    shouldDeleteMarkups
  } = _ref25;
  return async dispatch => {
    dispatch(issuesBatchDeleteByIdSuccess({
      issueUids
    }));
    dispatch((0, _issueTableSelection.removeIdsFromSelectedIdsAction)({
      issueUids
    }));
    // @TODO: switch this to a single API call: for now it's doing one request per deleted issue
    // which would not scale well if deleting a ton of issues
    if (shouldDeleteMarkups) {
      issueUids.forEach(issueUid => {
        dispatch((0, _sheets.tryDeleteMarkup)({
          issueId: issueUid
        }));
      });
    }
  };
};
exports.bulkDeleteIssuesSuccess = bulkDeleteIssuesSuccess;
const bulkEditIssuesAction = _ref26 => {
  let {
    issueUids,
    editedAttributes,
    onSuccess,
    onFailure,
    onPartialFailure
  } = _ref26;
  return async (dispatch, getState, _ref27) => {
    let {
      sdk
    } = _ref27;
    if (issueUids.length === 0) {
      return [];
    }
    let issues = [];
    let failureInfo = [];
    dispatch(issueBatchUpdateByIdStart({
      issueUids,
      issueChanges: editedAttributes
    }));
    /**
     * The maximum limit on this batchUpdate request on the server is 100, but
     * if enough fields are entered the request can time out at numbers as low as 50,
     * so we set the # of issues per request pretty low at 25
     */
    const maxUidsPerRequest = 25;
    const batches = (0, _chunk.default)(issueUids, maxUidsPerRequest);
    const resolvedBatches = await Promise.allSettled(batches.map(batch => {
      return (0, _issuesCollection.performActionOnIssueBatchWithRetry)({
        batch,
        asyncAction: async _ref28 => {
          let {
            issueUids
          } = _ref28;
          return await sdk.Issues.batchUpdate({
            issueUids,
            attributes: editedAttributes
          });
        }
      });
    }));
    resolvedBatches.forEach(resolvedBatch => {
      if (resolvedBatch.status === "fulfilled") {
        if (resolvedBatch.value.responseData) {
          issues = issues.concat(resolvedBatch.value.responseData);
        }
        if (resolvedBatch.value.failureInfo.length) {
          failureInfo = failureInfo.concat(resolvedBatch.value.failureInfo);
        }
      } else {
        // this case should be VERY rare, perhaps never.
        // it would only occur if an error response was malformed in some way.
        console.error("Unexpected error with batch:", resolvedBatch.reason);
      }
    });
    // if there is failure info for every issue uid that was initially passed,
    // the whole action has failed.
    if (failureInfo.length === issueUids.length) {
      dispatch(issueBatchUpdateByIdFailure({
        issueUids
      }));
      onFailure && onFailure(failureInfo);
      return null;
    } else if (failureInfo.length) {
      // if the failureInfo array has a length (but it isn't as long as the initital set of issueUids)
      // then SOME issues failed to be edited and we should allow the caller to notify the user
      dispatch(issueBatchUpdateByIdFailure({
        issueUids: failureInfo.map(failData => failData.issueUid)
      }));
      onPartialFailure && onPartialFailure(failureInfo);
      dispatch(issueBatchUpdateByIdSuccess({
        issues
      }));
      return issues;
    } else {
      dispatch(issueBatchUpdateByIdSuccess({
        issues
      }));
      onSuccess && onSuccess();
      return issues;
    }
  };
};

/**
 * At some point, it would be good if the PATCH call to an issue that makes it unpublished would
 * give some indication in the response that access was removed from the current user.
 *
 * Lacking that, the cleanest way to check this is to make another request to the backend,
 * and to remove the issue based on whether the issue is now inaccessible.
 *
 * The acc-viewer should not need to do this, since it will use the flow for deriving
 * markup appearance when an issue gets unpublished, which includes a call to the backend.
 *
 * By taking this approach, we let the backend be the source of truth for a user's
 * ability to view an issue, instead of trying to duplicate the logic here on the client.
 */
exports.bulkEditIssuesAction = bulkEditIssuesAction;
const maybeRemoveFromLogAfterUnpublishAction = _ref29 => {
  let {
    id,
    onRemove
  } = _ref29;
  return async (dispatch, getState, _ref30) => {
    let {
      sdk
    } = _ref30;
    try {
      await sdk.Issues.get(id);
    } catch (err) {
      if (err.status === 403) {
        onRemove && onRemove();
        // from a client-side perspective, if we can't acces sthe issue after unpublishing it,
        // we treat it exactly the same as if it was deleted
        dispatch(issueDeleteByIdSuccess({
          id
        }));
      }
    }
  };
};
exports.maybeRemoveFromLogAfterUnpublishAction = maybeRemoveFromLogAfterUnpublishAction;
const maybeRemoveFromLogAfterBulkUnpublishAction = _ref31 => {
  let {
    issueUids: unpublishedIssueUids
  } = _ref31;
  return async (dispatch, getState, _ref32) => {
    let {
      sdk
    } = _ref32;
    const foundIssueUids = [];
    /**
     * The maximum limit on the batchGet request on the server is 200, so in the rare case that there are
     * more than 180 issues on a sheet we do concurrent requests.
     *
     * (we use a bit less than the server limit just for some headroom)
     */
    const maxUidsPerRequest = 180;
    const batches = (0, _chunk.default)(unpublishedIssueUids, maxUidsPerRequest);
    try {
      const responses = await Promise.all(batches.map(async idListForRequest => {
        return sdk.Issues.batchGet({
          limit: maxUidsPerRequest,
          offset: 0,
          filterBy: {
            id: idListForRequest
          }
        });
      }));
      responses.forEach(response => {
        if (response) {
          response.results.forEach(issue => {
            foundIssueUids.push(issue.id);
          });
        }
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("Error removing issues form log after unpublish: ".concat(e, ". "));
    }
    const unviewableIssueIds = (0, _difference.default)(unpublishedIssueUids, foundIssueUids);
    if (unviewableIssueIds.length) {
      dispatch(issuesBatchDeleteByIdSuccess({
        issueUids: unviewableIssueIds
      }));
      dispatch((0, _issueTableSelection.removeIdsFromSelectedIdsAction)({
        issueUids: unviewableIssueIds
      }));
    }
  };
};
exports.maybeRemoveFromLogAfterBulkUnpublishAction = maybeRemoveFromLogAfterBulkUnpublishAction;
const restoreIssuesAction = _ref33 => {
  let {
    issues,
    newIssueTypeId
  } = _ref33;
  return async (dispatch, getState, _ref34) => {
    let {
      sdk
    } = _ref34;
    dispatch(issuesRestoreStart({
      issues
    }));
    const issueIds = issues.map(i => i.id);
    return sdk.Issues.batchRestore({
      issueIds,
      newIssueTypeId
    }).finally(() => {
      dispatch(issuesRestoreEnd({
        issueIds
      }));
    });
  };
};
exports.restoreIssuesAction = restoreIssuesAction;
const unlinkIssueAction = _ref35 => {
  let {
    issue,
    onSuccess,
    onFailure
  } = _ref35;
  return async (dispatch, getState, _ref36) => {
    let {
      sdk
    } = _ref36;
    const issueChanges = {
      linkedDocuments: [],
      snapshotUrn: undefined,
      snapshotHasMarkups: false
    };
    dispatch(issueUpdateByIdStart({
      id: issue.id,
      issueChanges
    }));
    try {
      //Only the unlink is in the try block because we don't want to show an error if the fetchById is failing,
      //for the user the UI will look the same because of the optimistic update even if the fetch fails.
      await sdk.IssuePlacements.unlink(issue.id);
    } catch (error) {
      dispatch(issueUpdateByIdFailure({
        id: issue.id
      }));
      onFailure === null || onFailure === void 0 || onFailure(error);
      return;
    }
    const updatedIssue = await dispatch(fetchIssueByIdAction({
      id: issue.id
    }));
    dispatch(issueUpdateByIdSuccess(updatedIssue));
    onSuccess === null || onSuccess === void 0 || onSuccess();
  };
};
exports.unlinkIssueAction = unlinkIssueAction;
//# sourceMappingURL=issuesCollection.js.map